export const fnSelectMyNetworkConnections = (state) =>
  state.Profile?.MYNETWORK || [];

export default {};
